import {Injectable} from '@angular/core';
import {COIService} from '../coi.service';
import {Observable} from 'rxjs';
import {Enrollment, Utility} from '../../models';

@Injectable()
export class UtilityService extends COIService {
  create(utility: Utility): Observable<any> {
    return this.httpPost(`/utility/create`, utility);
  }

  readList(): Observable<{ message: string, utilityList: Utility[] }> {
    return this.httpGet('/utility/list');
  }

  update(utility: Utility): Observable<any> {
    const body = {utility};
    console.log('Updating Utility ' + JSON.stringify(body));
    return this.httpPut(`/utility/update`, utility);
  }

  delete(utility_id: number): Observable<any> {
    return this.httpDelete(`/utility/${utility_id}`);
  }

  approveAccount(account_id: number): Observable<{ message: string, account: Account }> {
    return this.httpPut(`/utility/approve_account`, {account_id: account_id});
  }

  declineAccount(account_id: number): Observable<{ message: string, account: Account }> {
    return this.httpPut(`/utility/decline_account`, {account_id: account_id});
  }

  approveEnrollment(enrollment_id: number): Observable<Enrollment> {
    return this.httpPut(`/utility/approve_enrollment`, {enrollment_id: enrollment_id});
  }

  declineEnrollment(enrollment_id: number): Observable<Enrollment> {
    return this.httpPut(`/utility/decline_enrollment`, {enrollment_id: enrollment_id});
  }
}
